module.exports = __webpack_public_path__ + "static/media/chevron-blue-right.0bb4e8b2.svg";